import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    certificate : {},
    loadingCertificate : false
};

export const certificateSlice = createSlice({
    name: "certificates",
    initialState,
    reducers: {
        setLoadingCertificates: (state, {payload}) => {
            state.loadingCertificate = payload;
        },
        setCertificates: (state, {payload}) => {
            state.certificate = payload;
        },
       
    },
});
export const certificateActions = certificateSlice.actions;

export default certificateSlice.reducer;
